import { render, staticRenderFns } from "./file_collect.vue?vue&type=template&id=1a641596&"
import script from "./file_collect.vue?vue&type=script&lang=js&"
export * from "./file_collect.vue?vue&type=script&lang=js&"
import style0 from "./file_collect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports